'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactLazyload = require('react-lazyload');

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

var _Modal = require('../Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _ContentCardImage = require('./ContentCardImage.css');

var _ContentCardImage2 = _interopRequireDefault(_ContentCardImage);

var _ContentCardImageGlobal = require('./ContentCardImageGlobal.css');

var _ContentCardImageGlobal2 = _interopRequireDefault(_ContentCardImageGlobal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var handleLoad = function handleLoad(e) {
  window.dispatchEvent(new Event('image-loaded'));
  e.target.classList.remove('lazyload');
  e.target.classList.add('lazyloaded');
  if (e.target.naturalHeight >= e.target.naturalWidth) {
    e.target.classList.add('portrait');
  } else {
    e.target.classList.add('landscape');
  }
};

var handleModalImgLoad = function handleModalImgLoad(e) {
  e.target.classList.remove('lazyload');
  e.target.classList.add('lazyloaded');
};

var ImageBox = function ImageBox(_ref) {
  var alt = _ref.alt,
      src = _ref.src,
      onClick = _ref.onClick,
      styleOverrides = _ref.styleOverrides;
  return _react2.default.createElement(
    'div',
    {
      onClick: onClick,
      role: 'presentation',
      className: 'jsx-' + _ContentCardImage2.default.__scopedHash + ' ' + 'img-container'
    },
    _react2.default.createElement('img', {
      alt: alt,

      src: src,
      onLoad: handleLoad,
      style: styleOverrides,
      className: 'jsx-' + _ContentCardImage2.default.__scopedHash + ' ' + 'image lazyload'
    }),
    _react2.default.createElement(_style2.default, {
      styleId: _ContentCardImage2.default.__scopedHash,
      css: _ContentCardImage2.default.__scoped
    }),
    _react2.default.createElement(_style2.default, {
      styleId: _ContentCardImageGlobal2.default.__hash,
      css: _ContentCardImageGlobal2.default
    })
  );
};

var ContentCardImage = function (_React$Component) {
  _inherits(ContentCardImage, _React$Component);

  function ContentCardImage(props) {
    _classCallCheck(this, ContentCardImage);

    var _this = _possibleConstructorReturn(this, (ContentCardImage.__proto__ || Object.getPrototypeOf(ContentCardImage)).call(this, props));

    _this.state = { modalOpen: false };
    _this.handleCloseClick = _this.handleCloseClick.bind(_this);
    _this.onImageClick = _this.onImageClick.bind(_this);
    return _this;
  }

  _createClass(ContentCardImage, [{
    key: 'onImageClick',
    value: function onImageClick() {
      if (this.props.modalEnabled) {
        this.setState({ modalOpen: true });
        window.scrollBy(0, 1); // Trigger modal lazyload.
        window.scrollBy(0, -1);
      }
    }
  }, {
    key: 'handleCloseClick',
    value: function handleCloseClick() {
      this.setState({ modalOpen: false });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _ContentCardImage2.default.__scopedHash + ' ' + 'root'
        },
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-' + _ContentCardImage2.default.__scopedHash + ' ' + ((this.props.modalEnabled ? 'pointer' : '') || '')
          },
          !this.props.hideGradient && _react2.default.createElement('div', {
            className: 'jsx-' + _ContentCardImage2.default.__scopedHash + ' ' + 'topGradient'
          }),
          _react2.default.createElement(
            _reactLazyload2.default,
            { height: 300, offset: 200, once: true, throttle: 200 },
            _react2.default.createElement(ImageBox, {
              alt: this.props.alt,
              src: this.props.src,
              onClick: this.onImageClick,
              styleOverrides: this.props.styleOverrides ? this.props.styleOverrides.contentCardImageStyles : null
            })
          ),
          !this.props.hideGradient && _react2.default.createElement('div', {
            className: 'jsx-' + _ContentCardImage2.default.__scopedHash + ' ' + 'bottomGradient'
          })
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-' + _ContentCardImage2.default.__scopedHash + ' ' + ((this.state.modalOpen ? 'modal-open' : 'hidden') || '')
          },
          _react2.default.createElement(
            _reactLazyload2.default,
            { height: 300, offset: 200, once: true, throttle: 200 },
            _react2.default.createElement(
              _Modal2.default,
              { modalOpen: this.state.modalOpen, handleCloseClick: this.handleCloseClick },
              _react2.default.createElement(
                'div',
                {
                  className: 'jsx-' + _ContentCardImage2.default.__scopedHash + ' ' + 'img-container'
                },
                _react2.default.createElement('img', {
                  alt: this.props.alt,

                  src: this.props.src,
                  onLoad: handleModalImgLoad,
                  style: this.props.styleOverrides ? this.props.styleOverrides.contentCardImageStyles : null,
                  className: 'jsx-' + _ContentCardImage2.default.__scopedHash + ' ' + 'image lazyload modal-image'
                })
              )
            )
          )
        ),
        _react2.default.createElement(_style2.default, {
          styleId: _ContentCardImage2.default.__scopedHash,
          css: _ContentCardImage2.default.__scoped
        }),
        _react2.default.createElement(_style2.default, {
          styleId: _ContentCardImageGlobal2.default.__hash,
          css: _ContentCardImageGlobal2.default
        })
      );
    }
  }]);

  return ContentCardImage;
}(_react2.default.Component);

ImageBox.propTypes = {
  alt: _propTypes2.default.string.isRequired,
  src: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  styleOverrides: _propTypes2.default.shape({
    contentCardImageStyles: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
  })
};

ImageBox.defaultProps = {
  styleOverrides: null
};

ContentCardImage.propTypes = {
  alt: _propTypes2.default.string.isRequired,
  src: _propTypes2.default.string.isRequired,
  modalEnabled: _propTypes2.default.bool,
  hideGradient: _propTypes2.default.bool,
  styleOverrides: _propTypes2.default.shape({
    contentCardImageStyles: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
  })
};

ContentCardImage.defaultProps = {
  modalEnabled: false,
  hideGradient: false,
  styleOverrides: null
};

exports.default = ContentCardImage;